<template>
  <!-- Projects Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: 0 }"
  >
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h6>IP列表</h6>
          <p>仅展示通过斗篷链接<span class="text-primary">过滤的流量</span></p>
        </a-col>
        <a-col
          :span="24"
          :md="12"
          style="display: flex; align-items: center; justify-content: flex-end"
        >
          <a-radio-group v-model="projectHeaderBtns" size="small">
            <a-radio-button value="access">已放行</a-radio-button>
            <a-radio-button value="block">已拦截</a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>
    </template>

    <a-table
      :columns="IPColumns"
      :data-source="accessList"
      :pagination="true"
      v-if="projectHeaderBtns == 'access'"
    >
      <template slot="country" slot-scope="country">
        <h6 class="m-0">
          <img
            :src="getFlagUrl(country)"
            alt=""
            style="width: 40px; height: 40px"
          />
          {{ country }}
        </h6>
      </template>
      <template slot="from" slot-scope="from">
        <a-tag color="#2db7f5"> 真实用户 </a-tag>
      </template>
      <template slot="device" slot-scope="device">
        <img
          :src="`images/${device}.png`"
          alt=""
          style="width: 40px; height: 40px"
        />
      </template>
    </a-table>

    <a-table
      :columns="IPColumns"
      :data-source="blockList"
      :pagination="true"
      v-if="projectHeaderBtns == 'block'"
    >
      <template slot="country" slot-scope="country">
        <h6 class="m-0">
          <img
            :src="getFlagUrl(country)"
            alt=""
            style="width: 40px; height: 40px"
          />
          {{ country }}
        </h6>
      </template>
      <template slot="device" slot-scope="device">
        <img
          :src="`images/${device}.png`"
          alt=""
          style="width: 40px; height: 40px"
        />
      </template>
      <template slot="from" slot-scope="from">
        <a-tag color="#f50" v-if="from.indexOf('facebook') !== -1">
          疑似假冒真实用户
        </a-tag>
        <a-tag color="#f50" v-if="from == ''"> 疑似爬虫 </a-tag>
        <a-tag
          color="#2db7f5"
          v-if="
            from.indexOf('3stock') !== -1 || from.indexOf('instagram') !== -1
          "
        >
          仿真环境
        </a-tag>
      </template>
    </a-table>
  </a-card>
  <!-- / Projects Table Card -->
</template>

<script>
import countryFlags from "@/utils/country-flag.json";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    accessList: {
      type: Array,
      default: () => [],
    },
    blockList: {
      type: Array,
      default: () => [],
    },
    IPColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Active button for the "Projects" table's card header radio button group.
      projectHeaderBtns: "access",
      countries: countryFlags,
    };
  },
  methods: {
    getFlagUrl(country) {
      // 根据国家代码找到对应的国旗 URL
      country = country.replace("The", "").trim();
      const find_country = this.countries.find((c) => c.country === country);
      if (find_country) {
        return find_country.flag;
      } else {
        return "https://example.com/default-flag.svg"; // 默认图片，或者其他处理方式
      }
    },
  },
};
</script>